import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './shared';
import {TenantGuard} from './shared/guard/tenant.guard';

const routes: Routes = [
  // {
  //   path: 'e2x',
  //   loadChildren: './e2x/e2x.module#E2xModule',
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'e2x-admin',
    loadChildren: './e2x-admin/admin-backend.module#AdminBackendModule',
    canActivate: [AuthGuard],
  },
  {
    path: 'business',
    loadChildren: './business/business.module#BusinessModule',
    canActivate: [TenantGuard, AuthGuard],
  },
  {
    path: 'utility',
    loadChildren: './utility/utility.module#UtilityModule',
    canActivate: [TenantGuard, AuthGuard],
  },
  {
    path: 'admin',
    loadChildren: './admin/admin.module#AdminModule',
    canActivate: [TenantGuard, AuthGuard],
  },
  {
    path: 'users',
    loadChildren: './users/users.module#UsersModule',
    canActivate: [TenantGuard],
  },
  {
    path: 'wait-list',
    loadChildren: './shared/modules/waitlist/waitlist.module#WaitlistModule',
  },
  {
    path: 'not-found',
    loadChildren: './shared/modules/not-found/not-found.module#NotFoundModule',
  },
  {
    path: '',
    loadChildren: './layout/layout.module#LayoutModule',
    canActivate: [TenantGuard, AuthGuard],
  },
  {
    path: '',
    loadChildren: './green-button/green-button.module#GreenButtonModule',
    canActivate: [TenantGuard],
  },
  {
    path: 'event/email/acknowledgement',
    loadChildren:
      './acknowledgement/acknowledgement.module#AcknowledgementModule',
  },
  {
    path: 'success-screen',
    loadChildren: './shared/modules/success-screen/success-screen.module#SuccessScreenModule',
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
